import Header from "components/Headers/Header";
import React, { useEffect, useState } from "react";
import { Card, CardBody, Col, Container, Row, Spinner, Button } from "reactstrap";
import { useDispatch, useSelector } from "react-redux";
import { getEductions } from "store/actions/blogActions";

const TutorialsInPage = () => {
  let dispatch = useDispatch();
  const [dataLoader, setDataLoader] = useState(true);
  const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth < 768);
  const { EductionVideos } = useSelector((state) => state.blog);

  useEffect(() => {
    dispatch(
      getEductions(() => {
        setDataLoader(false);
      })
    );
  }, [dispatch]);

  useEffect(() => {
    const handleResize = () => {
      setIsSmallScreen(window.innerWidth < 768);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <>
      <Header />
      <Container fluid className="mt--4">
        <Card className="shadow border-0 rounded-4 overflow-hidden mb-4">
          {/* Banner */}
          <div className="bg-gradient-primary p-4 text-white">
            <span className="text-uppercase tracking-wider font-weight-600 text-white-50" style={{ fontSize: "10px", letterSpacing: "1.5px" }}>
              ACADEMY & RESOURCES
            </span>
            <h2 className="text-white mb-0 mt-1 font-weight-700">
              Advancing Education for FHP
            </h2>
            <p className="text-white-50 mb-0 mt-2 font-weight-500" style={{ fontSize: "0.95rem" }}>
              Explore our comprehensive library of video guides and tutorials to learn how to master the FHP platform.
            </p>
          </div>

          <CardBody className="p-4" style={{ backgroundColor: "#f8fafc" }}>
            {dataLoader ? (
              <div className="text-center py-5">
                <Spinner color="primary" />
              </div>
            ) : (
              <Row className="d-flex align-items-stretch">
                {EductionVideos.map((e, index) => (
                  <Col md="6" lg="4" key={index} className="mb-4">
                    <Card className="shadow-sm border-0 rounded-4 h-100 bg-white">
                      <CardBody className="p-4 d-flex flex-column justify-content-between">
                        <div>
                          <div className="d-flex align-items-center mb-3">
                            <span 
                              className="d-flex align-items-center justify-content-center rounded-circle mr-3"
                              style={{ 
                                width: "40px", 
                                height: "40px", 
                                backgroundColor: "#eef2ff", 
                                color: "#5e72e4" 
                              }}
                            >
                              <i className="fas fa-video" style={{ fontSize: "15px" }}></i>
                            </span>
                            <span className="text-muted font-weight-700" style={{ fontSize: "11px", letterSpacing: "0.5px" }}>
                              TUTORIAL #{index + 1}
                            </span>
                          </div>
                          
                          <h4 className="text-dark font-weight-700 mb-4 h5" style={{ lineHeight: "1.4", minHeight: "44px" }}>
                            {e.title}
                          </h4>
                        </div>

                        <div>
                          <a
                            href={e.url}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <Button 
                              color="outline-primary" 
                              className="w-100 rounded-pill font-weight-bold"
                            >
                              <i className="fas fa-play mr-2"></i> Watch Tutorial
                            </Button>
                          </a>
                        </div>
                      </CardBody>
                    </Card>
                  </Col>
                ))}
              </Row>
            )}
          </CardBody>
        </Card>
      </Container>
    </>
  );
};

export default TutorialsInPage;
